import React from "react";
import { motion } from "framer-motion";
import { Lightbulb, FileSearch, HardHat, Key, ShieldCheck } from "lucide-react";

const STEPS = [
  { icon: Lightbulb, title: "Conception", desc: "Étude personnalisée et plans sur-mesure adaptés à votre budget et votre terrain.", duration: "2-4 semaines" },
  { icon: FileSearch, title: "Permis & Études", desc: "Démarches administratives, études de sol et obtention du permis de construire.", duration: "1-3 mois" },
  { icon: HardHat, title: "Construction", desc: "Réalisation par nos équipes expérimentées avec suivi de chantier hebdomadaire.", duration: "8-18 mois" },
  { icon: Key, title: "Livraison", desc: "Remise des clés avec visite détaillée et formation à vos équipements.", duration: "1 jour" },
  { icon: ShieldCheck, title: "Garantie & SAV", desc: "Garantie décennale et accompagnement après livraison pendant 10 ans.", duration: "10 ans" },
];

export default function MethodTimeline() {
  return (
    <section className="bg-[#F8FAFC] py-20 lg:py-24" data-testid="method-timeline">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <div className="text-[12px] text-[#E91E63] font-bold tracking-[0.3em] mb-3">// NOTRE MÉTHODE</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold leading-[1.1] tracking-tight text-[#0F1A3D]" style={{ fontFamily: "'Playfair Display', serif" }}>
            5 étapes pour réussir<br />votre projet immobilier
          </h2>
        </motion.div>

        <div className="relative">
          {/* Ligne horizontale décorative */}
          <div className="hidden lg:block absolute top-7 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-transparent via-[#E91E63]/40 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.title}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className="relative text-center"
                  data-testid={`step-${i + 1}`}
                >
                  {/* Numero étape */}
                  <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-7 h-7 rounded-full bg-white border-2 border-[#E91E63] flex items-center justify-center font-bold text-[11px] text-[#E91E63] z-10">
                    {i + 1}
                  </div>
                  {/* Icon */}
                  <div className="w-14 h-14 mx-auto bg-white border-2 border-[#E91E63] rounded-full flex items-center justify-center mt-0">
                    <Icon className="w-6 h-6 text-[#1E3A8A]" strokeWidth={1.8} />
                  </div>
                  {/* Texte */}
                  <h3 className="font-display text-lg font-extrabold text-[#0F1A3D] mt-5 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {s.title}
                  </h3>
                  <div className="text-[10px] uppercase tracking-wider text-[#E91E63] font-bold mt-1">{s.duration}</div>
                  <p className="text-xs text-[#4B5775] leading-relaxed mt-3 px-2">{s.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
